<h2 mat-dialog-title>{{ latex() ? 'Edit Equation' : 'Insert Equation' }}</h2>

<mat-dialog-content>

  <label class="eq-label">LaTeX expression</label>
  <textarea
    class="eq-input"
    [value]="latex()"
    (input)="onLatexChange($any($event.target).value)"
    placeholder="e.g. E = mc^2"
    rows="4"
    spellcheck="false"
    autocomplete="off">
  </textarea>

  <label class="eq-label">Preview</label>
  <div #preview class="eq-preview">
    <span class="eq-placeholder">Preview will appear here</span>
  </div>

  <div *ngIf="hasError()" class="eq-hint">
    Tip: use <code>\frac{{ '{' }}a{{ '}' }}{{ '{' }}b{{ '}' }}</code>, <code>\sqrt{{ '{' }}x{{ '}' }}</code>, <code>\sum_{{ '{' }}i=0{{ '}' }}^{{ '{' }}n{{ '}' }}</code>, etc.
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="insert()" [disabled]="hasError() || !latex().trim()">
    {{ latex() ? 'Update' : 'Insert' }}
  </button>
</mat-dialog-actions>
